(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Hero header mobile menu
    var menuToggle = document.querySelector('[data-pawtee-menu-toggle]');
    var mobileNav = document.querySelector('[data-pawtee-mobile-nav]');
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function () {
        var isOpen = !mobileNav.hidden;
        mobileNav.hidden = isOpen;
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
        menuToggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      });

      document.addEventListener('click', function (event) {
        if (mobileNav.hidden) return;
        if (!event.target.closest('[data-pawtee-hero-header]')) {
          mobileNav.hidden = true;
          menuToggle.setAttribute('aria-expanded', 'false');
          menuToggle.setAttribute('aria-label', 'Open menu');
        }
      });
    }

    // FAQ accordion
    document.querySelectorAll('.pawtee-faq__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pawtee-faq__item');
        var wasActive = item.classList.contains('active');
        document.querySelectorAll('.pawtee-faq__item.active').forEach(function (el) {
          el.classList.remove('active');
        });
        if (!wasActive) item.classList.add('active');
      });
    });

    // Key features image hover
    var kfSection = document.querySelector('.pawtee-kf');
    if (!kfSection) return;
    var mainImg = kfSection.querySelector('.pawtee-kf__image .main-image');
    var listItems = kfSection.querySelectorAll('.pawtee-kf__item[data-image]');
    var featured = kfSection.querySelectorAll('.pawtee-kf__image .featured-image');
    if (!mainImg || !listItems.length) return;

    listItems.forEach(function (item, index) {
      item.addEventListener('mouseenter', function () {
        mainImg.classList.remove('show');
        featured.forEach(function (img, i) {
          img.classList.toggle('show', i === index);
        });
      });
    });

    var list = kfSection.querySelector('.pawtee-kf__list');
    if (list) {
      list.addEventListener('mouseleave', function () {
        mainImg.classList.add('show');
        featured.forEach(function (img) { img.classList.remove('show'); });
      });
    }
  });
})();
